import { Typography } from '@mui/material';

export const Loading = () => {
  return <Typography variant="body2">Loading...</Typography>;
};
